import { IconButton, TextField, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import DropdownDatatypeSelector from './DropdownDatatypeSelector';
import DatatypeInput from './FormController';
import { MetadataFieldSelectorProps } from './types';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import RadioButtonsExtraProps from './ExtraPropsForDatatypeComp/RadioButtonsExtraProps';

function MetadataFieldSelector(props: MetadataFieldSelectorProps) {
  const { getMetadata, metadata, hideValues = false } = props;
  const [selectedDataType, setSelectedDatatype] = React.useState(metadata?.propertyType);
  const [labelName, setLabelName] = React.useState(metadata?.propertyName);
  const [dataInputValue, setDataInputValue] = React.useState<any>(metadata?.propertyValue);
  const [fieldIsRequired, setFieldIsRequired] = React.useState(false);
  const [extraDatatypeProps, setExtraDatatypeProps] = React.useState<any>();


  const handleDataInputTypeChange = (template: string) => {
    setSelectedDatatype(template);
    getMetadata && getMetadata({
      key: metadata?.key,
      propertyName: labelName,
      fieldIsRequired: fieldIsRequired,
      propertyType: template,
      propertyValue: dataInputValue,
    });
  };

  const handleLabelNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLabelName(e.target.value);
    getMetadata && getMetadata({
      key: metadata?.key,
      propertyName: e.target.value,
      fieldIsRequired: fieldIsRequired,
      propertyType: selectedDataType,
      propertyValue: dataInputValue,
    });
  };

  const handleChangeRequired = () => {
    const newRequiredState = !fieldIsRequired;
    getMetadata && getMetadata({
      key: metadata?.key,
      propertyName: labelName,
      fieldIsRequired: newRequiredState,
      propertyType: selectedDataType,
      propertyValue: dataInputValue,
    });
    setFieldIsRequired(newRequiredState);
  };


  // useEffect(() => {
  //   getMetadata && getMetadata({
  //     key: metadata?.key,
  //     propertyName: labelName,
  //     fieldIsRequired: fieldIsRequired,
  //     propertyType: selectedDataType,
  //     propertyValue: dataInputValue,
  //   });
  // }, [selectedDataType, labelName, dataInputValue, fieldIsRequired]);


  // useEffect(() => {
  //   setSelectedDatatype(metadata?.propertyType);
  //   setLabelName(metadata?.propertyName);
  //   setDataInputValue(metadata?.propertyValue);
  // }, [metadata?.propertyName, metadata?.propertyValue]);

  // useEffect(() => {
  //   setDataInputValue('');
  // }, [selectedDataType]);

  const updateEntries = (entries: any) => {
    getMetadata && getMetadata({
      key: metadata?.key,
      propertyName: labelName,
      fieldIsRequired: fieldIsRequired,
      propertyType: selectedDataType,
      propertyValue: dataInputValue,
    });
    setExtraDatatypeProps(entries);
    setDataInputValue(entries);
  };

  return (<>
    <Box display='flex' gap={5}>

      {<>
        <Box display='flex' flexDirection='column'>
          <TextField
            sx={{ minWidth: 358 }}
            value={labelName || ''}
            onChange={handleLabelNameChange}
            label='Όνομα πεδίου' />


          {(selectedDataType === 'radio' || selectedDataType === 'checkbox') && <RadioButtonsExtraProps
            entries={dataInputValue}
            getEntries={(entries) => updateEntries(entries)}
          />}
        </Box>
        <Box minWidth='358px'>
          <DropdownDatatypeSelector
            value={selectedDataType}
            onSelect={handleDataInputTypeChange}
          />
        </Box>
      </>
      }
      {!hideValues &&
        <DatatypeInput
          extraDatatypeProps={extraDatatypeProps}
          inputType={selectedDataType}
          width={358}
          value={selectedDataType === 'date'
            ? dataInputValue || null
            : dataInputValue}
          onSelect={(data) => setDataInputValue(data)}
          label={
            <Box display='flex' flexDirection='row'>
              {labelName}
              {fieldIsRequired && <Tooltip placement='top' title={'Αναγκαστικό πεδίο'}>
                <div style={{ color: 'red' }}>*</div>
              </Tooltip>}
            </Box>
          }
        />
      }


      <Tooltip title={fieldIsRequired
        ? 'Υποχρεωτικό Πεδίο'
        : 'ΜΗ Υποχρεωτικό Πεδίο'}>

        <IconButton onClick={handleChangeRequired}
          aria-label='required'>
          {fieldIsRequired
            ? <PriorityHighIcon color='error' />
            : <QuestionMarkIcon />}
        </IconButton>

      </Tooltip>
    </Box>
  </>);
}

export default MetadataFieldSelector;